export const videoLinks = {
    trailers: [
        ['Come Back To Me', 'https://res.cloudinary.com/dmdcrs852/video/upload/v1553168682/10900774_847239618650814_1572168420_n.mp4'],
        ['Araf Zamani', 'https://res.cloudinary.com/dmdcrs852/video/upload/v1553168927/1176852_10151778365038944_61915_n.mp4'],
    ]
};
